import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

// @src imports
import { Modal } from 'src/chrome'
import suspenseBoundary from 'src/chrome/SuspenseBoundary/suspenseBoundaryHOC'
import { getGift, GiftFragment } from 'src/graphql'
import { useQueries, useState } from 'src/hooks'

import GiftDetails from './GiftDetails'
import ModalFooter from './ModalFooter/ModalFooter'

type Props = {
  slug: string
  onClose: () => void
  addGift: (gift: GiftFragment) => void
}

type ContentKey = 'description' | 'contents' | 'packaging' | 'shipping'

const contentKeys: { [slideIndex: number]: ContentKey } = {
  0: 'description',
  1: 'contents',
  2: 'packaging',
  3: 'shipping',
}

const GiftModal: React.FC<Props> = props => {
  const [slideIndex, setSlideIndex] = useState(0)
  const { addGift, slug, onClose } = props

  const [gift] = useQueries(getGift({ slug }))

  return (
    <Modal
      title={gift.name}
      imageUrl={gift.defaultVariation?.defaultImageUrl ?? ''}
      bodyChildren={
        <GiftDetails
          content={gift.defaultVariation?.[contentKeys[slideIndex]] ?? ''}
        />
      }
      footerChildren={
        <ModalFooter
          gift={gift}
          index={slideIndex}
          handleChange={setSlideIndex}
          addGift={addGift}
        />
      }
      onClose={onClose}
      animationStyle={'fade'}
    />
  )
}

export default suspenseBoundary({
  component: GiftModal,
  unresolved: (
    <Modal title="" onClose={() => {}} bodyChildren={<CircularProgress />} />
  ),
  failure: () => <></>,
})
